/**
 * Variant pills fit (Size ≤7 / Color ≤5).
 * Equal flex columns via CSS; this script only compresses gap → padding when labels would clip.
 * Never scrolls. Singleton init. No global API pollution.
 */
(function () {
  if (document.documentElement.hasAttribute('data-variant-pills-fit')) return;
  document.documentElement.setAttribute('data-variant-pills-fit', '');

  var FLOOR_GAP = 2;
  var FLOOR_PAD_SIZE = 4;
  var FLOOR_PAD_COLOR = 6;
  var ROW_SELECTOR = '.product-form__input-options';
  var LABEL_SELECTOR = 'input[type="radio"] + label';

  var frame = 0;
  var resizeObserver = null;
  var preferredGap = 8;
  var preferredPad = 16;

  function readPreferred() {
    var styles = getComputedStyle(document.documentElement);
    preferredGap = parseFloat(styles.getPropertyValue('--variant-pills-row-gap')) || 8;
    preferredPad = parseFloat(styles.getPropertyValue('--variant-pills-horizontal-padding')) || 16;
  }

  function labelsClipped(row) {
    var labels = row.querySelectorAll(LABEL_SELECTOR);
    for (var i = 0; i < labels.length; i++) {
      if (labels[i].scrollWidth > labels[i].clientWidth + 1) return true;
    }
    return false;
  }

  function applyVars(row, gap, pad) {
    row.style.setProperty('--variant-fit-gap', gap + 'px');
    row.style.setProperty('--variant-fit-pad-x', pad + 'px');
  }

  /**
   * Compress gap then padding until labels fit. Binary-search padding to limit reflows.
   */
  function fitRow(row) {
    if (!row.querySelector(LABEL_SELECTOR)) return;

    var layout = row.getAttribute('data-option-layout') || 'default';
    var floorPad = layout === 'size' ? FLOOR_PAD_SIZE : FLOOR_PAD_COLOR;
    var gap = preferredGap;
    var pad = preferredPad;

    applyVars(row, gap, pad);
    if (!labelsClipped(row)) return;

    while (gap > FLOOR_GAP && labelsClipped(row)) {
      gap -= 1;
      applyVars(row, gap, pad);
    }
    if (!labelsClipped(row)) return;

    var lo = floorPad;
    var hi = pad;
    while (lo < hi) {
      var mid = (lo + hi + 1) >> 1;
      applyVars(row, gap, mid);
      if (labelsClipped(row)) {
        hi = mid - 1;
      } else {
        lo = mid;
      }
    }
    applyVars(row, gap, lo);
  }

  function fitAll() {
    readPreferred();
    var rows = document.querySelectorAll(ROW_SELECTOR);
    for (var i = 0; i < rows.length; i++) fitRow(rows[i]);
  }

  function schedule() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(fitAll);
  }

  function bindObservers() {
    if (typeof ResizeObserver === 'undefined') return;

    if (resizeObserver) resizeObserver.disconnect();

    resizeObserver = new ResizeObserver(schedule);
    var roots = document.querySelectorAll('variant-radios');
    if (roots.length) {
      for (var i = 0; i < roots.length; i++) resizeObserver.observe(roots[i]);
    } else {
      var rows = document.querySelectorAll(ROW_SELECTOR);
      for (var j = 0; j < rows.length; j++) resizeObserver.observe(rows[j]);
    }
  }

  function onSectionUpdate() {
    bindObservers();
    schedule();
  }

  function init() {
    fitAll();
    bindObservers();

    if (typeof ResizeObserver === 'undefined') {
      window.addEventListener('resize', schedule, { passive: true });
    }

    document.addEventListener('shopify:section:load', onSectionUpdate);
    document.addEventListener('ajax:loaded', onSectionUpdate);
    document.addEventListener('ajax:before', function () {
      if (resizeObserver) resizeObserver.disconnect();
      cancelAnimationFrame(frame);
    });
    document.addEventListener('shopify:section:reorder', onSectionUpdate);
    document.addEventListener('shopify:section:unload', function (event) {
      var section = event.target;
      if (!resizeObserver || !section || !section.querySelector) return;
      if (section.querySelector('variant-radios, ' + ROW_SELECTOR)) {
        resizeObserver.disconnect();
        resizeObserver = null;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
